const today = new Date();
export const initialStateMR = {
    user: {
        email: '',
        password: '',
        token: '',
        login: false,
        error: false,
        msgError: '',
        newPassword: '',
        vendor: '',
        sucursal: '',
        opcusu: null,
        isAdmin: false,
        todaySales: 0,
        yesterdaySales: 0,
        test: false,
        level: 0,
        legajo: '',
        name: '',
        address: '',
        sex: '',
        nro: 0,
        disableInputs: false,
        hash: null,
    },
    codpmpol: '',
    sinisterDelete: '',
    nomlcia: null,
    company: null,
    empresas: [],
    sections: [],
    availableSections: [],
    sinistersSections: [],
    sinistersStates: [],
    companies: [],
    nameCompany: '',
    menu: [],
    cities: [],
    provinces: [],
    countries: [],
    activities: [],
    products: [],
    consultaProductos: [],
    motoQuotes: [],
    relationship: [],
    cards: [],
    arrPayMethod: [],
    payMethodMoto: [],
    loading: false,
    show: false,
    vendors: [],
    sucursales: [],
    regions: [],
    zones: [],
    optState: [],
    coverages: [],
    causes: [],
    optTypeUser: [],
    opcEnabled: [],
    mawdy: {},
    saveError: {
        errorDescription: '',
        section: '',
        recid: '',
        details: [],
    },
    infoCompany: {
        abremp: "",
        codemp: "",
        cuiemp: "",
        domemp: "",
        nomemp: "",
        telemp: "",
    },
    moto: {
        motoBrand: [],
        motoModel: [],
        motoSumAssured: [],
    },
    pets: {
        name: '',
        type: '',
        birthdate: '',
    },
    firstStep: {
        type: 'familiar',
        codsec: 8,
        codpro: '',
        codcia: 0,
        dni: '',
        cuil: '',
        email: '',
        birthday: '',
        province: '',
        city: '',
        brand: '',
        year: new Date().getFullYear(),
        model: '',
        sumAssured: '',
        payMethod: '',
        plan: '',
        price: '',
        facpol: '',
        codpos: '',
    },
    titularData: {
        name: '',
        lastname: '',
        address: '',
        numAddress: '',
        between: '',
        department: '',
        city: '',
        province: '',
        postalcode: '',
        genre: '',
        area: '',
        phone: '',
        activity: 0,
        expose: false,
        nationality: '',
    },
    homeData: {
        address: '',
        homeType: '',
        province: '',
        numAddress: '',
        department: '',
        city: '',
        squareMeters: '',
        registeredAddress: '',
    },
    tecnologyData: {
        name: '',
        lastname: '',
        modelo: '',
        product: '',
        dni: '',
        birthdate: '',
        marca: '',
    },
    payMethod: {
        id: null,
        creditCard: '',
        cardNumber: '',
        fullName: '',
        dni: '',
        expires: '',
    },
    vehicleData: {
        brand: '',
        isNew: 'yes',
        year: '',
        patent: '',
        registeredPatent: [],
        model: '',
        motor: '',
        chassis: '',
        use: 'particular',
    },
    waitingCities: false
}

export const initialStateAR = {
    policies: [],
    sinisters: [],
    sinFilters: {
        dateDenuncyFrom: null,
        dateDenuncyTo: null,
        payedFrom: null,
        payedTo: null,
        dni: '',
        sinsin: '',
        state: '',
        vendor: '',
        codsec: '',
        ciapol: '',
    },
    polFilters: {
        currentPage: 0,
        lastPage: 0,
        filters: {
            'cod-emp': '',
            'cod-cia': '',
            'cod-sec': [],
            'est-pol': [],
            'ven-usu': '',
            'dfe-pol': new Date(today.setDate(today.getDate() - 7)),
            'hfe-pol': new Date(),
            'dni-pol': '',
            'iii-pol': '',
            'cod-reg': '',
            'cod-suc': '',
            'web-pol': '',
            'pat-pol': '',
            'sub-emp': '',
            'maw-pol': false,
            active: false,
        },
    },
    cities: [],
    enterprises: [],
    statics: {
        s: {
            empleados: 0,
            datasets: [],
            iniciadas: 0,
            finalizadas: 0,
            canceladas: 0,
            ventas: [],
            sucursales: [],
            regiones: [],
            zonas: [],
            loaded: false,
        },
        r: {
            empleados: 0,
            datasets: [],
            iniciadas: 0,
            finalizadas: 0,
            canceladas: 0,
            ventas: [],
            sucursales: [],
            regiones: [],
            zonas: [],
            loaded: false,
        },
        z: {
            empleados: 0,
            datasets: [],
            iniciadas: 0,
            finalizadas: 0,
            canceladas: 0,
            ventas: [],
            sucursales: [],
            regiones: [],
            zonas: [],
            loaded: false,
        },
        a: {
            empleados: 0,
            datasets: [],
            iniciadas: 0,
            finalizadas: 0,
            canceladas: 0,
            ventas: [],
            sucursales: [],
            regiones: [],
            zonas: [],
            loaded: false,
        },
    },
    policy: {
        'cod-emp': 0,
        'int-pol': 0,
        'ori-pol': 0,
        'cod-cia': 0,
        'cod-sec': '',
        'cod-pro': '',
        'ven-usu': '',
        'cod-loc': '',
        'cod-pag': 0,
        'dni-pol': 0,
        'cui-pol': '',
        'ema-pol': '',
        'nac-pol': new Date(),
        'nom-pol': '',
        'ape-pol': '',
        'dom-pol': '',
        'sex-pol': '',
        'tel-pol': '',
        'cod-act': 0,
        'exp-pol': false,
        'cod-pai': '',
        'cod-tar': '',
        'tnum-pol': '',
        'tnom-pol': '',
        'tdni-pol': 0,
        'tvto-pol': '',
        'idv-pol': 0,
        'cam-pol': '',
        'com-pol': '',
        'fec-pol': new Date(),
        'fv1-pol': new Date(),
        'cod-doc': '',
        'cod-zon': '',
        'cod-viv': 0,
        'icod-loc': '',
        'mts-pol': 0,
        'cod-usu': '',
        'cod-suc': '',
        'pre-pol': 0,
        'sum-pol': 0,
        'sms-pol': '',
        'fv2-pol': new Date(),
        'cer-pol': '',
        'cal-pol': '',
        'num-pol': '',
        'pis-pol': '',
        'dep-pol': '',
        'rie-pol': 0,
        'cap-pol': 0,
        'imp-pol': 0,
        'inf-pol': '',
        'pri-pol': '',
        'ckm-pol': false,
        'pat-pol': '',
        'mot-pol': '',
        'cha-pol': '',
        'uso-pol': '',
        'ble-pol': false,
        'wsi-pol': '',
        'wso-pol': '',
        'ben-pol': '',
        'ano-pol': 0,
        'cod-prv': null,
        'icod-prv': null,
        'nom-prv': null,
        'fas-pol': '',
        'das-pol': '',
        'mod-pol': '',
        'mar-pol': '',
        'nas-pol': '',
        'aas-pol': '',
    },
}
